import RelationshipPrimaryInfoComponent from './RelationshipPrimaryInformationContainer';

export default RelationshipPrimaryInfoComponent;
